import React, { ChangeEvent, useCallback, useEffect, useState } from 'react';
import { CustomFilterProps, useGridFilter } from 'ag-grid-react';
import {
  IAfterGuiAttachedParams,
  IDoesFilterPassParams,
} from 'ag-grid-community';
import { filterStyles } from './styles';
import { ProductTypes } from 'lib/api/generated';

export default ({
  model,
  onModelChange,
  getValue,
  ...rest
}: CustomFilterProps) => {
  const [closeFilter, setCloseFilter] = useState<(() => void) | undefined>();
  const [unappliedModel, setUnappliedModel] = useState(model);

  const doesFilterPass = useCallback(
    (params: IDoesFilterPassParams) => {
      const filterText: string = model;
      switch (filterText) {
        case ProductTypes.Ct:
        case ProductTypes.Gt:
        case ProductTypes.Sh:
          return params.data.product === filterText;
        default:
          return true;
      }
    },
    [model]
  );

  const afterGuiAttached = useCallback(
    ({ hidePopup }: IAfterGuiAttachedParams) => {
      setCloseFilter(() => hidePopup);
    },
    []
  );

  // register filter handlers with the grid
  useGridFilter({
    doesFilterPass,
    afterGuiAttached,
  });

  useEffect(() => {
    setUnappliedModel(model);
  }, [model]);

  const onProductChange = ({
    target: { value },
  }: ChangeEvent<HTMLInputElement>) => {
    onModelChange(value === 'All' ? null : value);
    if (closeFilter) {
      closeFilter();
    }
  };

  return (
    <div style={filterStyles.container}>
      <div>Select Product</div>
      <label>
        <input
          type='radio'
          name='product'
          value='All'
          checked={unappliedModel === null}
          onChange={onProductChange}
        />{' '}
        All
      </label>
      <label>
        <input
          type='radio'
          name='product'
          value='CT'
          checked={unappliedModel === 'CT'}
          onChange={onProductChange}
        />{' '}
        Cattle
      </label>
      <label>
        <input
          type='radio'
          name='product'
          value='GT'
          checked={unappliedModel === 'GT'}
          onChange={onProductChange}
        />{' '}
        Goat
      </label>
      <label>
        <input
          type='radio'
          name='product'
          value='SH'
          checked={unappliedModel === 'SH'}
          onChange={onProductChange}
        />{' '}
        Sheep
      </label>
    </div>
  );
};
